import { ChangeDetectorRef, Component, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Subject } from 'rxjs';
import { ManagementApiService } from 'src/app/services';
import { CustomToastService } from 'src/app/services/custom-toast.service';
import { InstanceDataService } from 'src/app/services/instance-data.service';
import { OrganizationDataService } from 'src/app/services/organization-data.service';
import { UserUtilityService } from 'src/app/services/user-utility.service';
import { DeleteDialogComponent } from 'src/app/shared/info-dialogs/delete-dialog/delete-dialog.component';
import {
    ActivityIcon,
    ActivityPackStatus,
    ActivityPackType,
    ActivityStatusType,
    ActivityTagStandard,
} from '../../../models/instance/activity-pacck-type.model';
import { CreateActivityPackModalComponent } from '../../modals/organization/create-activity-pack-modal/create-activity-pack-modal.component';
import { AppConstants } from 'src/app/constants/appconstants';
import { takeUntil } from 'rxjs/operators';
import { CustomAvatarService } from 'src/app/services/custom-avatar.service';
@Component({
    selector: 'app-instance-activity-packs',
    templateUrl: './instance-activity-packs.component.html',
    styleUrls: ['./instance-activity-packs.component.scss'],
    standalone: false,
})
export class InstanceActivityPacksComponent implements OnInit, OnDestroy {
    destroy$ = new Subject();

    tooltip_position = 'above';
    newActivityPackTypeList: ActivityPackType[];
    defaultActivityPackSchema: string;
    currentOrganizationName: string;
    isNextButtonClicked: boolean;
    currentInstanceId: string;
    // currentInstanceIdSubscription: Subscription;
    defaultStatusTypeList: ActivityStatusType[];
    defaultActivityPackStatusList: ActivityPackStatus[]; // this for the use to while creating the new Activity pack type
    defaultActivityPackIcons: ActivityIcon[];
    defaultActivityPackTypeList: ActivityPackType[];
    defaultActivityTagStandardList: ActivityTagStandard[];
    isCheckUncheck: boolean;
    isSaveDefultsave: boolean = false;
    constructor(
        private ngbModal: NgbModal,
        private organizationDataService: OrganizationDataService,
        private instanceDataService: InstanceDataService,
        private managementApiService: ManagementApiService,
        private ngxUiLoaderService: NgxUiLoaderService,
        private activatedRoute: ActivatedRoute,
        private customToastService: CustomToastService,
        private userUtilityService: UserUtilityService,
        private changeDetector: ChangeDetectorRef,
        private customAvatarService: CustomAvatarService
    ) {
        this.organizationDataService.currentOrganizationName.pipe(takeUntil(this.destroy$)).subscribe((orgName) => {
            this.currentOrganizationName = orgName;
        });
        this.currentInstanceId = this.activatedRoute.snapshot.paramMap.get('id');
        this.newActivityPackTypeList = [];
        this.defaultActivityPackStatusList = [];
        this.isNextButtonClicked = false;
        this.defaultActivityPackTypeList = [];
        this.isCheckUncheck = false;
    }

    ngOnInit() {
        // this.getDefaultSchema();

        this.instanceDataService.instanceActiveTab.pipe(takeUntil(this.destroy$)).subscribe(async (res) => {
            if (res == AppConstants.tab_activityPacks) {
                await this.getDefaultStatusType();
                await this.getDefaultActivityIcons();
                if (this.activatedRoute.snapshot.paramMap.get('id')) {
                    this.currentInstanceId = this.activatedRoute.snapshot.paramMap.get('id');
                } else {
                    this.currentInstanceId = this.instanceDataService.instanceDetails.instanceId;
                }

                await this.getActivityPackByInstanceId(this.currentInstanceId);
                await this.getDefaultActivityTagStanderds(this.currentInstanceId);
                //    this.savePreDefinedActivityPackType();
            }
        });

        this.instanceDataService.instanceTabNext.pipe(takeUntil(this.destroy$)).subscribe((resp) => {
            if (resp == AppConstants.tab_activityPacks) {
                const selectednewActivityPackTypeList = this.newActivityPackTypeList?.filter((x) => x.isSelected == true).length > 0 ? true : false;
                const selecteddefaultActivityPackTypeList = this.defaultActivityPackTypeList?.filter((x) => x.isSelected == true).length > 0 ? true : false;

                if (selectednewActivityPackTypeList || selecteddefaultActivityPackTypeList) {
                    this.nextButtonClick();
                } else {
                    this.customToastService.errorToast('Please select Activity Pack Type(s) to continue.', 'Error');
                }
            }
        });

        this.instanceDataService.instanceTabBack.pipe(takeUntil(this.destroy$)).subscribe((resp) => {
            if (resp == AppConstants.tab_activityPacks) {
                this.navigateBack();
            }
        });
    }

    // * helper method to create activity pack type
    createActivityPackType() {
        let dialogRef = this.ngbModal.open(CreateActivityPackModalComponent, {
            size: 'lg',
            backdrop: 'static',
            keyboard: false,
        });
        const activityPackTypeNameList = this.defaultActivityPackTypeList.map((type) => {
            return type.name;
        });
        dialogRef.componentInstance.modalMode = 'add';
        dialogRef.componentInstance.activityPackNameList = this.getActivityPackTypeNames();
        dialogRef.componentInstance.activityPackTypeSchema = this.instanceDataService.defaultActivityPackSchema;
        dialogRef.componentInstance.defaultActivityPackTypeList = this.defaultActivityPackTypeList.slice();
        dialogRef.componentInstance.defaultActivityPackStatusList = this.defaultActivityPackStatusList.slice();
        dialogRef.componentInstance.defaultActivityIconList = this.defaultActivityPackIcons;
        dialogRef.componentInstance.defaultActivityTagStandardList = this.defaultActivityTagStandardList;
        dialogRef.result
            .then(async (result: ActivityPackType) => {
                if (result) {
                    await this.saveActivityPackDetail(result);
                }
            })
            .catch((error) => {
                console.warn(error);
            });
    }

    // * helper method for modifying activity pack type
    openViewActivityTypeModal(activityPackType: ActivityPackType) {
        let dialogRef = this.ngbModal.open(CreateActivityPackModalComponent, {
            size: 'lg',
            keyboard: false,
            backdrop: 'static',
        });
        dialogRef.componentInstance.activityPackNameList = this.getActivityPackTypeNames().filter((name) => name != activityPackType.name);
        dialogRef.componentInstance.activityPackTypeDescription = activityPackType.description;
        dialogRef.componentInstance.activityPackTypeName = activityPackType.name;
        dialogRef.componentInstance.activityPackTypeSchema = this.instanceDataService.defaultActivityPackSchema;
        dialogRef.componentInstance.activityPackType = activityPackType;
        dialogRef.componentInstance.defaultActivityPackTypeList = this.defaultActivityPackTypeList.slice();
        dialogRef.componentInstance.modalMode = 'edit';
        dialogRef.componentInstance.defaultActivityIconList = this.defaultActivityPackIcons;
        dialogRef.componentInstance.defaultActivityTagStandardList = this.defaultActivityTagStandardList;
        dialogRef.result
            .then(async (result: ActivityPackType) => {
                if (result) {
                    await this.saveActivityPackDetail(result);
                }
            })
            .catch((error) => {
                console.warn(error);
            });
    }

    navigateBack() {
        this.instanceDataService.instanceNavigationHandler(11);
    }

    cancelButtonClick() {
        this.instanceDataService.navigateThroughWizard.next(0);
    }

    // * helper method to get activity pack type names
    getActivityPackTypeNames(): string[] {
        const nameList = () => {
            return this.defaultActivityPackTypeList.map((type) => type.name);
        };
        return nameList();
    }

    // * api call to get the default activity pack types
    async getDefaultActivityPackTypes() {
        try {
            if (!this.defaultActivityPackTypeList?.length) {
                this.ngxUiLoaderService.start();
                let response = await this.managementApiService.getDefaultActivityPackTypes().toPromise();
                if (response.success) {
                    this.defaultActivityPackTypeList = response.response;
                    // this.defaultActivityPackTypeList.forEach((item) => {
                    //     item.isSelected = false;
                    // });
                    // this.newActivityPackTypeList = response.response;
                    this.ngxUiLoaderService.stop();
                    this.changeDetector.detectChanges();
                    if (!this.activatedRoute.snapshot.paramMap.get('id')) {
                        if (!this.isSaveDefultsave) {
                            this.savePreDefinedActivityPackType();
                        }
                    }
                } else if (response.isCustom) {
                    this.ngxUiLoaderService.stop();
                    this.userUtilityService.errorModelPopup(response.message);
                }
            }
        } catch (e) {
            this.ngxUiLoaderService.stop();
            this.customToastService.errorToast('Error while getting the activity pack types', 'Error');
        }
    }

    // * api call to save the activity pack type
    async nextButtonClick() {
        try {
            if (this.newActivityPackTypeList.length > 0) {
                this.ngxUiLoaderService.start();
                let response = await this.managementApiService.updateActivityPackType(this.currentInstanceId, this.newActivityPackTypeList).toPromise();

                if (response.success === true) {
                    this.isCheckUncheck = false;
                    this.customToastService.successToast('Activity pack types saved successfully', 'Success');
                    this.ngxUiLoaderService.stop();
                    this.newActivityPackTypeList = [];
                    await this.getActivityPackByInstanceIdApiCall(this.currentInstanceId);
                    this.instanceDataService.instanceNavigationHandler(10);
                } else {
                    this.userUtilityService.errorModelPopup(response.message);
                }
            } else {
                // if (!this.activatedRoute.snapshot.paramMap.get('id')) {
                //     this.customToastService.errorToast('Please select Activity Pack Type(s) to continue.', 'Error');
                // } else {
                //     this.instanceDataService.instanceNavigationHandler(10);
                // }
                this.instanceDataService.instanceNavigationHandler(10);
            }
        } catch (e) {
            this.ngxUiLoaderService.stop();
            this.customToastService.errorToast('Error while saving the activity pack', 'Error');
        }
    }

    //* helper method to delete the activity pack type
    deleteActivityPackType(activityPackType: ActivityPackType) {
        let dialogRef = this.ngbModal.open(DeleteDialogComponent, {
            size: 'sm',
        });
        dialogRef.componentInstance.modalMessage = `<p>Do you want to delete <b>${activityPackType.name}</b> activity pack type? </p>`;
        dialogRef.result
            .then((result) => {
                if (result) {
                    this.deleteActivityPackTypeFromDb(activityPackType.activityPackTypeId);
                }
            })
            .catch((err) => {
                console.warn(err);
            });
    }

    // * api call to get the activity pack by instanceId
    async getActivityPackByInstanceId(instanceId: string) {
        if (!this.defaultActivityPackTypeList?.length) {
            await this.getActivityPackByInstanceIdApiCall(instanceId);
        }
    }

    async getActivityPackByInstanceIdApiCall(instanceId: string) {
        try {
            this.ngxUiLoaderService.start();
            const response = await this.managementApiService.getActivityPackByInstanceId(instanceId).toPromise();

            if (response.success === true) {
                this.instanceDataService.activityPackTypeList.next(response.response); // * emiting data for activity workflow screen
                this.defaultActivityPackTypeList = response.response;
                this.ngxUiLoaderService.stop();
                if (!response.response.length) {
                    await this.getDefaultActivityPackTypes();
                }
            } else {
                this.ngxUiLoaderService.stop();
            }
        } catch (e) {
            this.ngxUiLoaderService.stop();
        }
    }

    // * handle check/uncheck of activity pack type
    checkUncheckActivityPackType(event, activityPackType: ActivityPackType) {
        this.isCheckUncheck = true;
        let index = this.defaultActivityPackTypeList.findIndex((type) => type.activityPackTypeId == activityPackType.activityPackTypeId);
        if (index !== -1) {
            this.defaultActivityPackTypeList[index].isSelected = event.checked;
        }
        let targetIndex = this.newActivityPackTypeList.findIndex((type) => type.activityPackTypeId == activityPackType.activityPackTypeId);
        if (targetIndex == -1) {
            this.newActivityPackTypeList = [...this.newActivityPackTypeList, this.defaultActivityPackTypeList[index]];
        } else {
            this.newActivityPackTypeList[targetIndex] = this.defaultActivityPackTypeList[index];
        }
    }

    // * api call to get the default status type
    async getDefaultStatusType() {
        try {
            if (!this.defaultStatusTypeList?.length) {
                this.ngxUiLoaderService.start();
                let response = await this.managementApiService.getDefaultStatusType().toPromise();

                if (response.success === true) {
                    this.defaultStatusTypeList = response.response;
                    this.instanceDataService.setActivityStatusType(response.response);
                    response.response.forEach((item) => {
                        let activityPackStatusType = new ActivityPackStatus();
                        activityPackStatusType.name = item.name;
                        activityPackStatusType.colour = item.colour;
                        activityPackStatusType.isSelected = true;
                        activityPackStatusType.activityPackTypeStatusType = item;
                        this.defaultActivityPackStatusList.push(activityPackStatusType);
                    });
                    this.ngxUiLoaderService.stop();
                } else {
                    this.ngxUiLoaderService.stop();
                    this.userUtilityService.errorModelPopup(response.message);
                }
            }
        } catch (e) {
            this.ngxUiLoaderService.stop();
            this.customToastService.errorToast('Error while getting the activity pack types', 'Error');
        }
    }

    // * api call to get the default activity icons
    async getDefaultActivityIcons() {
        try {
            if (!this.defaultActivityPackIcons?.length) {
                this.ngxUiLoaderService.start();
                let response = await this.managementApiService.getActivityPackIcons().toPromise();

                if (response.success === true) {
                    this.defaultActivityPackIcons = response.response;
                    this.ngxUiLoaderService.stop();
                } else if (response.isCustom) {
                    this.ngxUiLoaderService.stop();
                    this.userUtilityService.errorModelPopup(response.message);
                }
            }
        } catch (e) {
            this.ngxUiLoaderService.stop();
        }
    }

    // * save default activity pack types
    async savePreDefinedActivityPackType() {
        try {
            if (!this.currentInstanceId) return;
            this.ngxUiLoaderService.start();
            let response = await this.managementApiService.updateActivityPackType(this.currentInstanceId, this.defaultActivityPackTypeList).toPromise();

            if (response.success === true) {
                this.isNextButtonClicked = true;
                this.isSaveDefultsave = true;
                await this.getActivityPackByInstanceIdApiCall(this.currentInstanceId);
            } else {
                this.ngxUiLoaderService.stop();
            }
            this.ngxUiLoaderService.stop();
        } catch (e) {
            this.ngxUiLoaderService.stop();
        }
    }

    // * api call to save the activity pack type
    async saveActivityPackDetail(activityPackType: ActivityPackType) {
        if (!this.currentInstanceId) return;

        this.newActivityPackTypeList = [];
        try {
            this.ngxUiLoaderService.start();
            let response = await this.managementApiService
                .updateActivityPackType(this.currentInstanceId, [...new Set([...this.newActivityPackTypeList, activityPackType])])
                .toPromise();

            this.ngxUiLoaderService.stop();
            if (response.success === true) {
                this.newActivityPackTypeList = [];
                this.customToastService.successToast('Activity pack type saved successfully!');
                this.getActivityPackByInstanceIdApiCall(this.currentInstanceId);
            } else if (response.isCustom) {
                this.userUtilityService.errorModelPopup(response.message);
                this.userUtilityService.errorModelPopup(response.message);
                this.ngxUiLoaderService.stop();
            }
        } catch (err) {
            this.ngxUiLoaderService.stop();
            this.customToastService.errorToast('Unable to save Activity pack type. Please try again later or contact administrator', 'Error');
        }
    }

    // * api call to delete the activity pack type
    deleteActivityPackTypeFromDb(activityPackId: string): void {
        let targetInd = this.newActivityPackTypeList.findIndex((item) => item.activityPackTypeId == activityPackId);
        if (targetInd != -1) this.newActivityPackTypeList.splice(targetInd, 1);
        this.ngxUiLoaderService.start();
        this.managementApiService.updateActivityPackType(this.currentInstanceId, [{ activityPackTypeId: activityPackId, active: false }]).subscribe(
            async (response) => {
                this.ngxUiLoaderService.stop();
                if (response.success) {
                    this.customToastService.successToast('Activity pack type deleted successfully!', 'Success');
                    if (!this.isCheckUncheck) {
                        await this.getActivityPackByInstanceIdApiCall(this.currentInstanceId);
                    } else {
                        // * removing from array
                        let index = this.defaultActivityPackTypeList.findIndex((item) => item.activityPackTypeId == activityPackId);
                        if (index != -1) {
                            this.defaultActivityPackTypeList.splice(index, 1);
                        }
                    }
                } else if (response.isCustom) {
                    this.userUtilityService.errorModelPopup(response.message);
                }
            },
            (error) => {
                this.ngxUiLoaderService.stop();
            }
        );
    }

    //* api call  api call to get the default tag standard List
    async getDefaultActivityTagStanderds(currentInstanceId) {
        if (!this.defaultActivityTagStandardList?.length) {
            this.ngxUiLoaderService.start();
            let response = await this.managementApiService.getDefaultActivityTagStandard(currentInstanceId).toPromise();

            if (response.success === true) {
                this.defaultActivityTagStandardList = response.response;
            } else {
                this.userUtilityService.errorModelPopup(response.message);
            }
            this.ngxUiLoaderService.stop();
            if (response.isCustom) {
                this.ngxUiLoaderService.stop();
                this.customToastService.errorToast('Error while getting the tag standards', 'Error');
            }
        }
    }

    getInitials(name: string): string {
        if (!name) return '';
        return this.customAvatarService.getShortInitials(name);
    }

    ngOnDestroy(): void {
        // this.currentInstanceIdSubscription.unsubscribe();
        this.destroy$.next(null);
        this.destroy$.complete();
    }
}
